import React, { memo, useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import T from '@prisjakt/ui-translate';
import Breadcrumb from '@prisjakt/ui-breadcrumb';
import { bemGenerator } from '@prisjakt/ui-base';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import EmailSent from '../../../components/email-sent';
import './index.scss';

const styles = bemGenerator('change-email-confirm', ['link']);

const EmailChangeConfirmPage = ({ email }) => {
  const { t, market } = useContext(AppContext);
  return [
    <EmailSent
      key="change-email-confirm"
      email={email}
      market={market}
      title={t('account', 'change-email.confirm-title')}
      information={t('account', 'change-email.confirm-information')}
      checkEmailNotice={<T domain="account">change-email.confirm-notice.md</T>}
      breadcrumbComponent={
        <Breadcrumb
          homeText={t('common', 'breadcrumb.home')}
          path={[
            {
              pathName: '/account',
              name: t('account', 'my-account.title'),
              id: '0',
            },
            {
              pathName: '/account/settings',
              name: t('account', 'settings.title'),
              id: '1',
            },
            {
              pathName: '/account/settings/email-change/confirm',
              name: t('account', 'change-email.confirm-title'),
              id: '2',
            },
          ]}
        />
      }
    />,
    <div key="change-email-confirm-back-link" className="row">
      <div className="columns small-12">
        <p>
          {t('account', 'back-to-settings.text', {
            link: (
              <Link
                key="back-to-settings.link"
                className={styles.link}
                to="/account/settings"
              >
                {t('account', 'back-to-settings.link')}
              </Link>
            ),
          })}
        </p>
      </div>
    </div>,
  ];
};

const { string } = PropTypes;

EmailChangeConfirmPage.propTypes = {
  email: string.isRequired,
};

export default memo(EmailChangeConfirmPage);
